<template lang='pug'>
    v-container(style='')
        template(v-if="mode == 'generate_answer' && show")
            v-skeleton-loader.mb-2(type='text' width='70%')
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='60%')
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='80%')
            v-skeleton-loader.mb-2(type='text' width='60%')
        template(v-else-if="mode == 'related_questions'")
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='100%')
        template(v-else-if="mode == 'step_response_answer'")
            v-skeleton-loader.mb-2(type='text' width='100%')
            v-skeleton-loader.mb-2(type='text' width='100%')
        template(v-else-if="mode == 'reference'")
            v-row.reference-selecton
                v-col.pl-0.pr-2(cols='3' v-for='n in 4' :key="'row1-'+n")
                    v-skeleton-loader(type='image') 
        template(v-else-if="mode == 'agents'")
            v-row.agentslist-selecton.justify-center
                v-col.pl-0.pr-0.pr-md-3.py-2(cols='11' md='4' v-for='n in 3' :key="'agent-row-'+n")
                    v-skeleton-loader(type='image')
        template(v-else-if="mode == 'related_images'")
            v-row.reference-selecton
        template(v-else)
            v-skeleton-loader.mb-2(v-for="n in line" :key="'line-'+n" type='text' width='100%')
</template>
<script>
export default {
    name: "portalGenerateAnswerSkeleton",
    components: {
    },
    data() {
        return{
            
        }
    },
    props: {
        mode: {
            type: String,
        },
        line: {
            type: Number
        },
        show: {
            type: Boolean,
            default: true
        }
    },
}
</script>
<style scoped lang="css">

</style>